import React from "react";
import moment from "moment";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import {
  getEndtime,
  getPassedMinutesOnlyTimeSeconds,
  isAgendaItemActive,
} from "../../helper/timeCalculations";

const color1 = "#C7DFC7";
const color2 = "#BFD9E2";
const colorHighlight = "#9A4B4F";

let topic = "-";
let timeCount = "";

const overlayStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
};

const centerOverlayStyle = {
  ...overlayStyle,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

// One same-size ring per agenda item, each restricted to its own slice of
// the circle (via circleRatio + rotation) and layered on top of the others.
// This used to be a ring nested inside a ring inside a ring, one level per
// card, which compounds badly: every extra card shrank all the rings inside
// it a little further, so a long agenda (e.g. a full-day Pomodoro schedule
// with dozens of cards) squeezed the inner rings down to slivers and piled
// their semi-transparent trails on top of each other, washing the whole
// ring out to a dark blur. Same-size, non-overlapping slices keep every
// session's color distinct no matter how many cards are on the table.
function RecursiveProgressbar({
  array,
  strokeWidth,
  starttime,
  maxValue,
  actualTime = moment(),
}) {
  let cumulativeSeconds = 0;
  let activeTopic = null;
  let activeCountdown = null;

  const segments = array.map((item, index) => {
    const durationSeconds = moment.duration(item.time).asSeconds();
    const itemArray = array.slice(0, index + 1);
    const isActive = isAgendaItemActive(itemArray, starttime, actualTime);

    if (isActive) {
      const itemEndTime = getEndtime(itemArray, starttime);
      activeTopic = item.topic;
      activeCountdown = moment
        .utc(
          moment
            .duration(
              Math.abs(
                getPassedMinutesOnlyTimeSeconds(itemEndTime, actualTime)
              ),
              "seconds"
            )
            .asMilliseconds()
        )
        .format("HH:mm:ss");
    }

    const segment = {
      key: item.id || `${index}`,
      circleRatio: maxValue > 0 ? durationSeconds / maxValue : 0,
      rotation: maxValue > 0 ? cumulativeSeconds / maxValue : 0,
      color: isActive ? colorHighlight : index % 2 === 0 ? color1 : color2,
    };
    cumulativeSeconds += durationSeconds;
    return segment;
  });

  topic = activeTopic || topic;
  timeCount = activeCountdown || timeCount;

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {segments.map((segment, index) => (
        <div key={segment.key} style={index === 0 ? undefined : overlayStyle}>
          <CircularProgressbar
            value={1}
            maxValue={1}
            circleRatio={segment.circleRatio}
            strokeWidth={strokeWidth}
            styles={buildStyles({
              rotation: segment.rotation,
              pathColor: segment.color,
              trailColor: "transparent",
              strokeLinecap: "butt",
            })}
          />
        </div>
      ))}
      <div style={centerOverlayStyle}>
        <div className="ring-center">
          <div className="ring-topic">{topic}</div>
          <div className="ring-countdown">{timeCount}</div>
        </div>
      </div>
    </div>
  );
}

export default RecursiveProgressbar;
